import type { Configuration, RedirectRequest } from '@azure/msal-browser';
import { LogLevel } from '@azure/msal-browser';

export const AUTH_ENABLED = import.meta.env.VITE_AUTH_MODE === 'enabled';

const clientId = import.meta.env.VITE_AZURE_AD_CLIENT_ID;
const tenantId = import.meta.env.VITE_AZURE_AD_TENANT_ID;
const apiScope = import.meta.env.VITE_AZURE_AD_API_SCOPE;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage', // safer than localStorage; survives tab refresh, dies with browser
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        // Only log warnings and errors in production. Verbose in dev for debugging.
        if (import.meta.env.DEV) {
          console.log(`[MSAL] ${LogLevel[level]}: ${message}`);
        } else if (level === LogLevel.Error || level === LogLevel.Warning) {
          console.warn(`[MSAL] ${LogLevel[level]}: ${message}`);
        }
      },
      logLevel: import.meta.env.DEV ? LogLevel.Info : LogLevel.Warning,
    },
  },
};

// Login request: scopes requested when the user signs in.
// We request our API scope so that we can later silently get an access token for it.
export const loginRequest: RedirectRequest = {
  scopes: [apiScope],
};

// Token request: scopes for silent token acquisition before each API call.
export const apiTokenRequest = {
  scopes: [apiScope],
};